import { render } from "./DocumentPdfTab.vue?vue&type=template&id=6b29c080"
import script from "./DocumentPdfTab.vue?vue&type=script&lang=js"
export * from "./DocumentPdfTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__